export default __webpack_public_path__ + "static/media/search-icon.1ca99e8a.svg";